import "text-encoding-polyfill";
import Joi from "joi";

const recreatePasswordSchema = Joi.object({
	password: Joi.string().min(5).max(20).required(),
	confirmPassword: Joi.string().valid(Joi.ref("password")).required(),
});

export default recreatePasswordSchema;
